import React, { useEffect, useMemo, useState } from "react";
import { Fade } from "react-awesome-reveal";
import "../styles/Carousel.scss";
import Whats from "./Whats";

// Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

// Imágenes
import img1 from "../images/carousel/1.jpg";
import img2 from "../images/carousel/2.jpg";
import img3 from "../images/carousel/3.jpg";
import img4 from "../images/carousel/4.jpg";

const Carousel = () => {
  const [anos, setAnos] = useState(0);
  const [eventos, setEventos] = useState(0);
  const [clientes, setClientes] = useState(0);

  const anosMax = 8;
  const eventosMax = 300;
  const clientesMax = 250;

  useEffect(() => {
    const a = setInterval(() => setAnos((p) => (p < anosMax ? p + 1 : p)), 90);
    const e = setInterval(() => setEventos((p) => (p < eventosMax ? p + 5 : p)), 20);
    const c = setInterval(() => setClientes((p) => (p < clientesMax ? p + 5 : p)), 30);

    return () => {
      clearInterval(a);
      clearInterval(e);
      clearInterval(c);
    };
  }, []);

  const slides = useMemo(
    () => [
      { img: img1, alt: "Banquetes al carbón en Guadalajara - Pixbae Banquetes" },
      { img: img2, alt: "Buffet de cortes al carbón - Pixbae Banquetes" },
      { img: img3, alt: "Buffet de tacos al carbón - Pixbae Banquetes" },
      { img: img4, alt: "Texas BBQ y buffet italiano para eventos - Pixbae Banquetes" },
    ],
    []
  );

  return (
    <section className="pxb-about" id="nosotros">
      <div className="pxb-about__container">
        <div className="pxb-about__row">
          {/* LEFT */}
          <div className="pxb-about__left">
            <Fade triggerOnce>
              <h2 className="pxb-about__title">
                Experiencia premium en <span>banquetes al carbón</span>
              </h2>
            </Fade>

            <p className="pxb-about__subtitle">
              Sabor, montaje y atención profesional para que tu evento se disfrute sin preocupaciones.
            </p>

            <p className="pxb-about__desc">
              En <strong>Pixbae Banquetes</strong> llevamos la experiencia de un chef profesional a tu
              evento, con servicio para <strong>reuniones residenciales</strong> y{" "}
              <strong>eventos empresariales</strong> en{" "}
              <strong>Guadalajara, Zapopan y Tlajomulco de Zúñiga</strong>.
            </p>

            <div className="pxb-about__stats">
              <div className="pxb-stat">
                <span className="pxb-stat__num">{`+${anos}`}</span>
                <span className="pxb-stat__label">Años de experiencia</span>
              </div>

              <div className="pxb-stat">
                <span className="pxb-stat__num">{`+${eventos}`}</span>
                <span className="pxb-stat__label">Eventos realizados</span>
              </div>

              <div className="pxb-stat">
                <span className="pxb-stat__num">{`+${clientes}`}</span>
                <span className="pxb-stat__label">Clientes satisfechos</span>
              </div>
            </div>

            <div className="pxb-about__cta">
              <Whats
                classStyle="btn pxb-btn"
                phoneNumber="523345851702"
                message="Hola, quiero cotizar un banquete. ¿Me compartes paquetes y disponibilidad?"
                text="Cotizar por WhatsApp"
              />
            </div>
          </div>

          {/* RIGHT */}
          <div className="pxb-about__right" aria-label="Galería de Pixbae Banquetes">
            <div className="pxb-slider">
              <Swiper
                modules={[Autoplay, Pagination]}
                slidesPerView={1}
                loop
                grabCursor
                pagination={{ clickable: true }}
                autoplay={{ delay: 3200, disableOnInteraction: false }}
                speed={750}
              >
                {slides.map((s, i) => (
                  <SwiperSlide key={i}>
                    <img src={s.img} alt={s.alt} loading="lazy" />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Carousel;
